import type { ReactNode } from 'react';
import { Alert, Box, Paper, Skeleton, Typography } from '@mui/material';

type ChartCardProps = {
  title: string;
  subtitle?: string;
  toolbar?: ReactNode;
  loading?: boolean;
  error?: string | null;
  children: ReactNode;
  minHeight?: number;
};

export function ChartCard({
  title,
  subtitle,
  toolbar,
  loading = false,
  error = null,
  children,
  minHeight = 320,
}: ChartCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        height: '100%',
      }}
    >
      <Box sx={{ mb: toolbar || subtitle ? 2 : 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
        {toolbar ? <Box sx={{ mt: 1.5 }}>{toolbar}</Box> : null}
      </Box>

      {loading ? (
        <Skeleton variant="rounded" height={minHeight} />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box sx={{ width: '100%', minHeight }}>{children}</Box>
      )}
    </Paper>
  );
}
